import { Autocomplete as autocompleteClasses } from "@mzc-pdc/ui";
import styled from "@emotion/styled";

export const StyledAutocompletePopper = styled("div")(({ theme }) => ({
    [`& .${autocompleteClasses.paper}`]: {
        boxShadow: "none",
        margin: "8px 0 0 0",
        color: "inherit",
        fontSize: 13,
    },
    [`& .${autocompleteClasses.listbox}`]: {
        // backgroundColor: theme.palette.mode === "light" ? "#fff" : "#1c2128",
        maxHeight: 200,
        padding: 0,
        [`& .${autocompleteClasses.option}`]: {
            minHeight: "auto",
            alignItems: "flex-start",
            padding: 8,
            borderBottom: `1px solid  ${theme.palette.mode === "light" ? " #eaecef" : "#30363d"}`,
            '&[aria-selected="true"]': {
                backgroundColor: "transparent",
            },
            [`&.${autocompleteClasses.focused}, &.${autocompleteClasses.focused}[aria-selected="true"]`]: {
                backgroundColor: theme.palette.action.hover,
            },
        },
    },
    [`&.${autocompleteClasses.popperDisablePortal}`]: {
        position: "relative",
    },
    [`& .${autocompleteClasses.noOptions}`]: {
        padding: 0,
        span: {
            marginTop: "5px",
            fontSize: "14px",
        },
    },
}));
